import { getRequestOptionDemoMode } from '@/utils/demoMode';
import { getStorageCompanyId } from '@/utils/localStorage';
import { request } from 'umi';

export const getCompanyAPI = async (options?: API.RequestOptions) => {
  const companyId = getStorageCompanyId();
  return request<API.Company>('/company', {
    params: { id: companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getAllCompanies = async () => {
  return request<API.Company[]>('/company/all', {
    method: 'GET',
    ...getRequestOptionDemoMode(),
  });
};

export const getAllCompaniesApi = async (params?: {
  page?: number;
  page_size?: number;
  ordering?: string;
  search?: string;
}) => {
  return request<API.PageDataType<API.Company>>('/company/all', {
    method: 'GET',
    params,
    ...getRequestOptionDemoMode(),
  });
};

export const getCompanyOptions = async () => {
  return request<{ id: string; name: string }[]>('/company/options', {
    method: 'GET',
    ...getRequestOptionDemoMode(),
  });
};

export const getCompanyById = async (companyId: string) => {
  return request<API.Company>(`/company/detail/${companyId}`, {
    method: 'GET',
    ...getRequestOptionDemoMode(),
  });
};

export const updateCompany = async (companyId: string, data: Partial<API.Company>) => {
  return request<API.Company>(`/company`, {
    method: 'PUT',
    params: { id: companyId },
    data,
    ...getRequestOptionDemoMode(),
  });
};
export const requestBindingCompany = async (companyId: string, data: API.CompanyBindingRequest) => {
  return request<API.CompanyBindingResponse>(`/company/bind`, {
    method: 'POST',
    params: { id: companyId },
    data,
    ...getRequestOptionDemoMode(),
  });
};

export const requestNewCompanyBinding = async (data: API.CompanyBindingRequest) => {
  return request<API.CompanyBindingResponse>(`/company/bind/new`, {
    method: 'POST',
    data,
    ...getRequestOptionDemoMode(),
  });
};

export const getCompanyBindingStatus = async (companyId: string) => {
  return request<API.CompanyBindingStatusResponse>(`/company/bind/status`, {
    method: 'GET',
    params: { id: companyId },
    ...getRequestOptionDemoMode(),
  });
};

// ==================== 成員管理 API ====================

export const getCompanyMembers = async (companyId: string, includeRevoked: boolean = false) => {
  return request<API.ExternalMember[]>(`/company/members`, {
    method: 'GET',
    params: { id: companyId, includeRevoked },
    ...getRequestOptionDemoMode(),
  });
};

export const batchInviteMembers = async (
  companyId: string,
  data: API.BatchInviteMembersRequest,
) => {
  return request<API.BatchInviteMembersResponse>(`/company/members/batch-invite`, {
    method: 'POST',
    params: { id: companyId },
    data,
    ...getRequestOptionDemoMode(),
  });
};

export const updateCompanyMember = async (
  companyId: string,
  memberId: string,
  data: API.UpdateMemberRequest,
) => {
  return request<API.ExternalMember>(`/company/members/${memberId}`, {
    method: 'PUT',
    params: { id: companyId },
    data,
    ...getRequestOptionDemoMode(),
  });
};

export const revokeCompanyMember = async (companyId: string, memberId: string) => {
  return request<API.ExternalMember>(`/company/members/${memberId}/revoke`, {
    method: 'POST',
    params: { id: companyId },
    ...getRequestOptionDemoMode(),
  });
};
